<!--  -->
<template>
	<div class="container">
		<div class="flex flex-container">
			<!-- 价格方案 -->
			<div class="flex-left">
				<div class="search-container flex flex-between">
					<div class="flex">
						<div class="title">预付款账户</div>
						<el-input v-model.trim="searchName" class="w190 ml15" size="small" placeholder="账户" maxlength="20" @keyup.enter.native="handleSearch" clearable>
						</el-input>
						<img class="icon-img ml10" src="@/assets/images/search.png" @click="handleSearch" alt="">
					</div>
					<div v-if="isEdit">
						<img class="icon-img ml7" src="@/assets/images/price.png" @click="handlePrice"  title="充值" alt="">
						<img class="icon-img ml7" src="@/assets/images/delete.png" @click="handleDelete"  title="删除" alt="">
						<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit"  title="新增" alt="">
					</div>
				</div>
				<div class="mt10">
					<el-table
						ref="multipleTable1"
						v-el-table-infinite-scroll="tableLoad"
						:height="height"
						:infinite-scroll-distance="50"
						:infinite-scroll-immediate="false"
						:data="tableData1"
						:row-class-name="tabRowClassName"
						:cell-style="cellStyle"
						:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
						@cell-click="handleCellClick"
						border style="width: 100%">
						<el-table-column width="60" label="选择" align="center">
							<template slot-scope="scope">
								<el-radio v-model="selecteId" :label="scope.row.accountId"></el-radio>
							</template>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="accountCode" width="130" label="预付款账号" sortable>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="accountName" min-width="140" label="预付款账户" sortable>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="balanceMoney" label="当前余额">
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="limitMoney" label="预警额">
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="remark" label="备注">
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!-- 价格明细 -->
			<div class="flex-right ml20">
				<div class="search-container  flex flex-between">
					<div class="title">使用账户的客商<span v-if="accountName" class="des-text ml10">({{accountName}})</span></div>
					<div v-if="isEdit">
						<img class="icon-img ml7" src="@/assets/images/delete.png" @click="handleChildDelete" title="删除" alt="">
						<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleAccountEdit" title="新增" alt="">
					</div>
				</div>
				<div class="mt10">
					<el-table
						ref="multipleTable2"
						v-el-table-infinite-scroll="tableLoadChild"
						:height="height"
						:infinite-scroll-distance="50"
						:infinite-scroll-immediate="false"
						:data="tableData2"
						:row-class-name="tabRowClassName"
						:header-cell-style="{background:'rgba(200, 204, 215,.6)',color:'#333333'}"
						@selection-change="handleSelectionChange"
						border style="width: 100%">
						<el-table-column type="selection" width="50" align="center">
						</el-table-column>
						<el-table-column prop="agentCode" width="130" :show-overflow-tooltip="true" label="客商编号" sortable>
						</el-table-column>
						<el-table-column prop="agentName" min-width="130"  :show-overflow-tooltip="true" label="客商名称" sortable>
						</el-table-column>
						<el-table-column prop="sapNo" min-width="130" :show-overflow-tooltip="true" label="客商SAP编号" sortable>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!--  -->
		</div>
		<prepayment ref="prepayment" @getList="handleBack"></prepayment>
		<accountRecharge ref="accountRecharge" @getList="handleBack"></accountRecharge>
		<addMerchants ref="addMerchants" @getAgentList="handleBackAgentList"></addMerchants>
	</div>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	import prepayment from './components/prepayment-account.vue'
	import accountRecharge from './components/account-recharge.vue'
	import addMerchants from './components/add-merchants.vue'
	import { hasPermission } from '@/utils/permission'
	export default {
		name:'subsist',
		components: {
			prepayment,
			accountRecharge,
			addMerchants
		},
		data() {
			return {
				height: 500,
				searchName: '',
				accountName: '',
				selecteId: '',
				currentData: '',
				pageNo: 1,
				pageSize: 40,
				childPageNo: 1,
				childPageSize: 40,
				multipleSelection: [],
				tableData1: [],
				tableData2: [],
				isEdit:false
			}
		},
		created() {
			this.height = window.innerHeight - 170;
			this.getList();
			if (this.$route.meta.perm) {
				this.isEdit = hasPermission(this.$route.meta.perm);
				// console.log(this.isEdit)
			}
		},
		methods: {
			tabRowClassName({
				row,
				rowIndex
			}) {
				let index = rowIndex + 1;
				if (index % 2 == 1) {
					return 'warning-row'
				}
			},
			cellStyle({row, column, rowIndex, columnIndex}) {
				if(columnIndex == 1) {
					return 'cursor: pointer;'
				}
			},
			// 充值回调
			handleBack(){
				this.pageNo = 1
				this.getList()
			},
			// 获取预付款账户列表
			getList(type) {
				let that = this;
				that.$request.post(
					"prepaidAccountList",
					true, {
						accountName: that.searchName,
						pageNo: that.pageNo,
						pageSize: that.pageSize
					}
				)
				.then((res) => {
					if (res) {
						if(type == 'scroll') {
							that.tableData1 = that.tableData1.concat(res.data.list);
						}else {
							that.tableData1 = res.data.list;
						}
					}
				})
			},
			tableLoad:debounce(function() {
				this.pageNo++;
				this.getList('scroll');
			},100,true),
			handleSearch() {
				if(this.tableData1.length > 0){
					this.$refs.multipleTable1.clearSelection();
					this.$refs.multipleTable1.bodyWrapper.scrollTop = 0;
				}
				this.pageNo = 1;
				this.$nextTick(() => {
					this.getList();
				})
			},
			// 新增/编辑
			handleEdit() {
				this.$refs.prepayment.init();
			},
			// 点击数据字典
			handleCellClick(row, column, cell, event) {
				if(column.label == '预付款账号') {
					this.$refs.prepayment.init(row);
				}else {
					this.selecteId = row.accountId;
					this.accountName = row.accountName;
					this.currentData = row;
					this.$refs.multipleTable2.bodyWrapper.scrollTop = 0;
					this.childPageNo = 1;
					this.getAgentList();
				}
			},
			// 删除数据字典
			handleDelete() {
				if(this.selecteId == ''){
					return
				}
				this.$confirm('确认要删除此预付款账户吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let that = this;
					that.$request.post(
						"prepaidAccountDelete",
						true, {
							accountIds: [that.selecteId]
						}
					)
					.then((res) => {
						if (res) {
							that.selecteId = '';
							that.accountName = '';
							that.handleSearch();
							that.$message.success('删除成功');
						}
					})
				}).catch(() => {

				});
			},
			// 充值
			handlePrice(){
				if(this.selecteId == '') {
					this.$message.error('请选择预付款账户');
					return
				}
				this.$refs.accountRecharge.init(this.currentData);
			},
			// 添加客商
			handleAccountEdit(){
				if(this.selecteId == '') {
					this.$message.error('请选择预付款账户');
					return
				}
 				this.$refs.addMerchants.init(this.currentData);
			},
			// 获取客商数据
			getAgentList(type) {
				let that = this;
				that.$request.post(
					"preaccountAgentList",
					true, {
						accountId: that.selecteId,
						pageNo: that.childPageNo,
						pageSize: that.childPageSize
					}
				)
				.then((res) => {
					if (res) {
						if(type == 'scroll') {
							that.tableData2 = that.tableData2.concat(res.data.list);
						}else {
							that.tableData2 = res.data.list;
						}
					}
				})
			},
			// 客商回调
			handleBackAgentList(){
				this.childPageNo=1
				this.getAgentList()
			},
			tableLoadChild:debounce(function() {
				this.childPageNo++;
				this.getAgentList('scroll');
			},100,true),
			// 列多选
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除数据字典
			handleChildDelete() {
				if(this.selecteId == ''){
					return
				}
				if(this.multipleSelection.length <= 0){
					this.$message.error('请先选择要移除的客商');
					return
				}
				let recordIds= []
				this.multipleSelection.forEach(item => {
					recordIds.push(item.recordId)
				});
				this.$confirm('确认要移除选择的客商吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					let that = this;
					that.$request.post(
						"preaccountAgentDelete",
						true, {
							accountId: that.selecteId,
							recordIds: recordIds
						}
					)
					.then((res) => {
						if (res) {
							that.$refs.multipleTable2.clearSelection();
							if(that.tableData2.length > 0) {
								that.$refs.multipleTable2.bodyWrapper.scrollTop = 0;
							}
							that.childPageNo = 1;
							that.getAgentList();
							that.$message.success('删除成功');
						}
					})
				}).catch(() => {

				});
			},
		},
		beforeDestroy() {

		}
	}

</script>

<style lang='scss' scoped>
	.container {
		// width: 99%;
		box-sizing: border-box;
			margin: 12px 26px 15px 10px;

		.el-table {

			// 深度选择器，去除默认的padding
			/deep/ th {
				padding: 0px;
			}

			/deep/ td {
				padding: 5px;
			}

			/deep/ .warning-row {
				background: #F1F1F5;
			}
			/deep/ th .el-table__cell{
				padding: 0 !important;
			}
		}
	}

	.search-container {
		 background: #F9FAFD;
         padding: 5px;
	}

	.flex-container {
		width: 100%;
		align-items: flex-start;
		box-sizing: border-box;
	}

	.flex-left {
		width: 55%;
		background: #fff;
		box-sizing: border-box;
		padding:10px;
	}

	.flex-right {
		width: 43%;
		background: #fff;
		box-sizing: border-box;
		padding:10px;
	}
.title{
	line-height: 32px;
}
</style>
<style scoped>
.cursor{
	cursor: pointer;
}
>>> .el-radio {
  margin-left: 6px;
}
>>> .el-radio .el-radio__label {
  display: none;
}
</style>
